
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function MSfabricationgrill() {



  const cardData =
  {
    keyword: ' MS Fabrication Grill Installation ',
    heading: 'Anjali Enterprises: MS Fabrication Grill Installation',
    headingDescription: 'Anjali Enterprises specializes in MS (Mild Steel) fabrication grill installation, offering custom solutions designed to enhance the security and aesthetic appeal of your space. Whether you need metal grills for windows, doors, or other areas, our expertly crafted MS grills provide robust protection while adding a decorative touch. We provide a wide range of MS fabricated grill solutions to meet both functional and stylistic needs for residential and commercial properties.',

    topPlaces: [
        {
          "title": "Steel Grill Work in Pune",
          "description": "We offer professional steel grill work services in Pune, specializing in custom designs that meet the highest standards of quality and security. Whether you need grills for windows, balconies, or doors, we ensure a perfect fit for your property."
        },
        {
          "title": "Custom MS Grills",
          "description": "Our custom MS grills are tailored to fit the unique design and security requirements of your space. We offer a wide variety of styles, from traditional to modern, ensuring that your security solutions also enhance the overall look of your property."
        },
        {
          "title": "Mild Steel Window Grills",
          "description": "Our mild steel window grills are designed to offer maximum protection while maintaining an aesthetic appeal. We provide grills that blend seamlessly with the architecture of your home or office, ensuring safety without compromising on style."
        },
        {
          "title": "MS Grills for Safety",
          "description": "Anjali Enterprises provides MS grills specifically designed for safety purposes, offering superior protection against intruders. These grills are crafted with durability and security in mind, making them ideal for homes, offices, and commercial spaces."
        },
        {
          "title": "Metal Grill Installation",
          "description": "We offer professional metal grill installation services, ensuring that your grills are securely fitted and function effectively. Our team works closely with you to design grills that complement your property’s exterior while providing optimal safety."
        },
        {
          "title": "Wrought Iron Grills",
          "description": "In addition to MS grills, we also offer wrought iron grills, known for their elegant and classic design. These grills combine beauty with strength, making them ideal for creating a sophisticated yet secure environment."
        },
        {
          "title": "MS Fabricated Grill for Windows",
          "description": "Our MS fabricated grills for windows provide a strong and durable solution for securing your property. We offer both standard and custom designs to suit your specific requirements, ensuring a perfect fit for your windows."
        },
        {
          "title": "Decorative Metal Grill Solutions",
          "description": "Anjali Enterprises specializes in decorative metal grill solutions that not only offer security but also enhance the visual appeal of your space. From intricate designs to simple, modern looks, we create grills that are both functional and stylish."
        },
        {
          "title": "Security Grills for Windows",
          "description": "We provide high-quality security grills for windows, designed to keep your home or office safe from intruders. Our grills are built to last and can be customized to match your property’s design while offering maximum security."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality MS (Mild Steel) fabrication grill installation services. We specialize in designing and fabricating durable MS grills for windows, doors, and balconies, providing enhanced security while maintaining an aesthetic appeal. Get in touch for expert installation and professional service. Serving Pune with top-notch MS fabrication grill solutions tailored to your needs."
        }
      ],
      "tableData": [
        ["- Steel Grill Work in Pune", "- Custom MS Grills"],
        ["- Mild Steel Window Grills", "- MS Grills for Safety"],
        ["- Metal Grill Installation", "- Wrought Iron Grills"],
        ["- MS Fabricated Grill for Windows", "- Decorative Metal Grill Solutions"],
        ["- Security Grills for Windows", "- Anjali Enterprises Contact Number"],
        ["", ""]
      ],
  


    "whychoose": [
  {
    "WhyChooseheading": "High Durability and Strength",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in MS (Mild Steel) fabrication grills that are built to last. These grills provide excellent security while offering long-term strength, durability, and protection for your property. Whether for windows, gates, or balconies, our MS grills are designed for maximum security and safety."
  },
  {
    "WhyChooseheading": "Customizable Designs",
    "WhyChoosedescription": "We offer a wide variety of design options for MS fabrication grills, allowing you to choose the best style for your property. Whether you prefer a simple, classic design or a more intricate, decorative pattern, our team can create grills tailored to your specifications."
  },
  {
    "WhyChooseheading": "Enhanced Security",
    "WhyChoosedescription": "MS fabrication grills are known for their strength and effectiveness in providing security. Our grills are made with robust materials, ensuring that your home, office, or business is well-protected from potential intruders."
  },
  {
    "WhyChooseheading": "Affordable and High-Quality",
    "WhyChoosedescription": "We offer high-quality MS grills at competitive prices. Using premium-grade mild steel, we ensure that every grill is durable, reliable, and built to withstand the test of time, all while being cost-effective for our customers."
  },
  {
    "WhyChooseheading": "Weather-Resistant",
    "WhyChoosedescription": "MS fabrication grills are treated with anti-corrosive coatings, making them resistant to rust and corrosion. This ensures that the grills will remain strong and maintain their appearance despite exposure to varying weather conditions."
  },
  {
    "WhyChooseheading": "Professional Installation",
    "WhyChoosedescription": "Our expert team provides hassle-free installation of MS fabrication grills. We ensure precise fabrication, timely delivery, and secure installation so that your property remains safe and the grills fit perfectly."
  },
  {
    "WhyChooseheading": "Versatile Applications",
    "WhyChoosedescription": "MS fabrication grills can be installed in various areas of your property, such as windows, balconies, gates, doors, and fences. They offer excellent protection while allowing air circulation and visibility."
  },
  {
    "WhyChooseheading": "Low Maintenance",
    "WhyChoosedescription": "MS fabrication grills require minimal maintenance. Regular cleaning and occasional checks ensure that they stay in great condition for years. We also offer maintenance services to keep your grills functioning perfectly."
  },
  {
    "WhyChooseheading": "Aesthetic Appeal",
    "WhyChoosedescription": "Our MS fabrication grills not only serve as protective barriers but also add aesthetic value to your property. With a variety of styles, we can create grills that complement your home or business decor."
  }
]



  }

  const faqData = [
    {
      question: "What is an MS fabrication grill?",
      answer: "An MS (Mild Steel) fabrication grill is a security grill made from mild steel. It provides protection against intruders while allowing for air circulation and visibility. MS grills are commonly used in windows, balconies, gates, and doors."
    },
    {
      question: "Can MS fabrication grills be customized?",
      answer: "Yes, MS fabrication grills can be fully customized according to your design preferences. We offer a wide range of styles, sizes, and patterns to match your security and aesthetic needs."
    },
    {
      question: "Are MS fabrication grills resistant to rust?",
      answer: "Yes, our MS fabrication grills are treated with anti-corrosive coatings to protect them from rust and corrosion. This ensures that they remain durable and maintain their appearance over time, even in harsh weather conditions."
    },
    {
      question: "Can MS fabrication grills be installed on existing windows or doors?",
      answer: "Yes, MS fabrication grills can be installed on existing windows, doors, or other openings. Our expert team ensures a perfect fit, providing added security and protection without compromising the structure of your property."
    },
    {
      question: "How long will MS fabrication grills last?",
      answer: "MS fabrication grills are built to last for many years with minimal maintenance. The quality materials and coatings used ensure that the grills remain strong, durable, and secure."
    },
    {
      question: "How do I maintain my MS fabrication grills?",
      answer: "MS fabrication grills require very little maintenance. Regular cleaning with mild soap and water is recommended. Additionally, periodic inspections will help ensure that the grills are functioning properly. We also offer maintenance services if needed."
    },
    {
      question: "Are MS fabrication grills suitable for residential and commercial properties?",
      answer: "Yes, MS fabrication grills are ideal for both residential and commercial properties. Whether for home security, office protection, or business premises, our grills provide effective and attractive solutions."
    },
    {
      question: "How much do MS fabrication grills cost?",
      answer: "The cost of MS fabrication grills depends on the design, size, and complexity of the project. We offer competitive pricing and customized quotes based on your specific needs. Contact us for a free consultation and quote."
    },
    {
      question: "Can MS fabrication grills be installed on balconies and terraces?",
      answer: "Yes, MS fabrication grills are perfect for balconies and terraces. We offer customizable solutions that provide security while enhancing the aesthetic appeal of these areas."
    },
    {
      question: "Why should I choose Anjali Enterprises for MS fabrication grill installation?",
      answer: "Anjali Enterprises provides high-quality MS fabrication grills with professional installation. Our grills offer enhanced security, durability, and aesthetic value for your property. With competitive pricing and excellent customer service, we are your trusted partner for MS grill solutions."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Amit Kapoor",
      text: "We installed MS fabrication grills on all the windows of our home, and we couldn't be more satisfied. The grills are strong, secure, and look great. Anjali Enterprises made the entire process smooth and hassle-free."
    },
    {
      name: "Ms. Neha Soni",
      text: "Anjali Enterprises installed MS fabrication grills for our commercial property. The grills are well-made, durable, and provide great security. The team was professional and completed the job on time. Highly recommended!"
    }
  ];
  


  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>



<Helmet>
  <title>MS Fabrication Grill Installation Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers MS fabrication grill installation services in Pune, providing custom steel grills, mild steel window grills, security grills, and decorative metal grill solutions for windows and more. Call +91 8793220265 for MS grill solutions." />
  <meta name="keywords" content="MS Fabrication Grill Installation, Steel Grill Work Pune, Custom MS Grills, Mild Steel Window Grills, MS Grills for Safety, Metal Grill Installation, Wrought Iron Grills, MS Fabricated Grill for Windows, Decorative Metal Grill Solutions, Security Grills for Windows" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | MS Fabrication Grill Installation Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers MS fabrication grill installation services in Pune, providing custom steel grills, mild steel window grills, security grills, and decorative metal grill solutions for windows and more. Call +91 8793220265 for MS grill solutions." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/ms-fabrication-grill-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/ms-fabrication-grill-installation" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers MS fabrication grill installation services in Pune, providing custom steel grills, mild steel window grills, security grills, and decorative metal grill solutions for windows and more. Call +91 8793220265 for MS grill solutions.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/ms-fabrication-grill-installation",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/ms-fabrication-grill-service.jpg",
        "priceRange": "₹2000 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/ms-fabrication-grill-installation",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "28"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikas R"
            },
            "datePublished": "2024-06-15",
            "reviewBody": "We had MS grills installed at our home, and the work was fantastic! Strong, durable, and well-crafted. Highly recommend Anjali Enterprises for anyone in need of quality steel grills."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Meera G"
            },
            "datePublished": "2024-09-12",
            "reviewBody": "The team at Anjali Enterprises installed beautiful wrought iron grills for our office. The quality was top-notch, and the service was quick and professional. Very happy with the results!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/ms-fabrication-grill-installation"
        },
        "keywords": "MS Fabrication Grill Installation, Steel Grill Work Pune, Custom MS Grills, Mild Steel Window Grills, MS Grills for Safety, Metal Grill Installation, Wrought Iron Grills, MS Fabricated Grill for Windows, Decorative Metal Grill Solutions, Security Grills for Windows"
      }
    `}
  </script>
</Helmet>


      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/12.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default MSfabricationgrill;